var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.25C11.586 11.25 11.25 10.914 11.25 10.5V3.5C11.25 3.086 11.586 2.75 12 2.75C12.414 2.75 12.75 3.086 12.75 3.5V10.5C12.75 10.914 12.414 11.25 12 11.25ZM20.75 13.5C20.75 10.395 19.074 7.4909 16.377 5.9209C16.021 5.7139 15.5611 5.83489 15.3521 6.19189C15.1441 6.54989 15.265 7.00904 15.623 7.21704C17.86 8.51804 19.25 10.925 19.25 13.499C19.25 17.497 15.998 20.749 12 20.749C8.002 20.749 4.75 17.497 4.75 13.499C4.75 10.926 6.13995 8.51904 8.37695 7.21704C8.73495 7.00904 8.85595 6.54989 8.64795 6.19189C8.43995 5.83389 7.98105 5.7129 7.62305 5.9209C4.92605 7.4899 3.25 10.394 3.25 13.5C3.25 18.325 7.175 22.25 12 22.25C16.825 22.25 20.75 18.325 20.75 13.5Z",
    fill: "#3A0299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.b9e6449753d9f723608349ca5c7a9c05.svg";
export { ForwardRef as ReactComponent };